import { el } from "./dom";

/**
 * "New version available" with Reload and ✕, above the tray. Nothing reloads
 * on its own while the game runs: the player decides, and a dismissed prompt
 * comes back at the next start.
 */
export function initUpdate(): {
  show(apply: () => Promise<void>): void;
  gameFailed(): void;
} {
  const pill = el("update");
  const reload = el<HTMLButtonElement>("updateReload");
  let apply: (() => Promise<void>) | null = null;
  let failed = false;
  reload.addEventListener("click", () => {
    // the page reloads once the new version has taken over
    reload.disabled = true;
    void apply?.();
  });
  el("updateDismiss").addEventListener("click", () => (pill.hidden = true));
  return {
    show(next) {
      apply = next;
      if (failed) return void next();
      reload.disabled = false;
      pill.hidden = false;
    },
    /**
     * The game couldn't start, and its error screen covers the prompt. Nothing
     * is lost by switching, so a waiting version (now or later) takes over at once.
     */
    gameFailed() {
      failed = true;
      void apply?.();
    },
  };
}
